<template>
  <div>
    <v-toolbar flat color="primary">
      <v-title>
        Order History
        <span class="caption d-flex justify-start ml-3">{{
        this.selectedcustomer.PARTYMST_DESC
      }}</span>
      </v-title>
      <v-progress-circular
          v-if="loading"
          indeterminate
          color="white"
          class="d-flex justify-center align-center"
        ></v-progress-circular>
        <v-spacer></v-spacer>
        <v-btn icon  @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar> 
    <v-sheet color="white">
      <!-- <v-progress-linear color="primary" v-show="loading"></v-progress-linear>
      <span class="caption d-flex justify-start ml-3">{{
        this.selectedcustomer.PARTYMST_DESC
      }}</span> -->
      <v-simple-table dense>
        <template v-slot:default>
          
          <thead>
            <tr>
              <th class="text-left caption" style="width:20%">
                Last pur. date
              </th>
              <th class="text-left caption" style="width:40%">
                Item
              </th>
              <th class="text-left caption" style="width:10%">
                Qty
              </th>
              <th class="text-left caption" style="width:10%">
                Unit
              </th>
              <th class="text-left caption" style="width:10%">
                Rate
              </th>
              <th class="text-left caption" style="width:10%">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="product in customerproductslist"
              :key="product.CL_STOCKCODE"
            >
              <td>{{ product.CL_DOCDATE }}</td>
              <td>{{ product.CL_STOCKDESC }}</td>
              <td class="text-right">{{ product.CL_QTY }}</td>
              <td>{{ product.CL_UNIT }}</td>
              <td class="text-right">{{ product.CL_RATE }}</td>
              <td class="text-right">{{ product.CL_NETAMT }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "Customerproducts",
  data() {
    return {};
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    selectedcustomer() {
      return this.$store.getters.thiscustomer;
    },
    customerproductslist() {
      return this.$store.getters.customerproducts;
    },
  },
  methods:{
    closeDialog() {
      this.$emit('hideCustProd');
    }
  },
  mounted() {
    console.log(this.customerproductslist);
  },
};
</script>

<style scoped></style>
